import React from "react";
import * as yup from "yup";
import { Form } from "react-final-form";
import Validator from "../../../../_helpers/validate.schema";
import UiCropFileUpload from "../../../_uiComponents/form/UiCropFileUpload";

const validateSchema = () =>
    yup.object().shape({

    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function UiCropFileUploadForm(props) {

    const submit = async (values) => {
       
    };

    return (
        <Form
            onSubmit={submit}
            validate={onValidate}
            mutators={{
                    setFormAttribute: (
                         [fieldName, fieldVal],
                         state,
                         { changeValue },
                    ) => {
                         changeValue(state, fieldName, () => fieldVal);
                    },
               }}
            render={({ form, handleSubmit, hasValidationErrors }) => (
                <form onSubmit={validateSchema}>
                    <UiCropFileUpload
                            aspectRatio={2 / 1}
                            minWidth="120"
                            label="Header Banner"
                            uploadSize="Min. image size 746px x 350px"
                            setUploadValue={(value) => {
                            form.mutators.setFormAttribute(
                                    "bannerFileId",
                                    value,
                            )}}
                            setCropImageArea={props.setCropImageArea}
                    />
                    
                </form>
            )}
        />
    );
}
